import Backtop from './src/backtop';

Backtop.install = function(Vue) {
  Vue.component(Backtop.name, Backtop);
};

export default Backtop;



// WEBPACK FOOTER //
// ./src/components/backtop/index.js